import { removeStyleVariable, setStyleVariable } from 'src/scripts/utils/dom'
import { BaseComponent } from '../../components/base-component'
import { debounce } from 'src/scripts/utils/debounce'

export class AnnouncementBar extends BaseComponent {
  resizeObserver: ResizeObserver

  mountComponent(): void {
    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)

    if (this.isEditor) {
      this.editor.on('SECTION_LOAD', this.handleSectionLoad)
      this.editor.on('SECTION_UNLOAD', this.handleSectionLoad)
    }
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()

    if (this.isEditor) {
      this.editor.off('SECTION_LOAD', this.handleSectionLoad)
      this.editor.off('SECTION_UNLOAD', this.handleSectionLoad)
    }
  }

  toggleStyleVariable = () => {
    const barStyles = getComputedStyle(this.parentElement)

    if (barStyles.position == 'sticky') {
      setStyleVariable(
        'sticky-bar-bottom',
        `${this.parentElement.offsetHeight + parseFloat(barStyles.top)}px`,
      )
    } else {
      removeStyleVariable('sticky-bar-bottom')
    }
  }

  handleResize = debounce(this.toggleStyleVariable, 100)

  handleSectionLoad = debounce(({ detail: { sectionId } }) => {
    if (this.dataset.sectionId === sectionId) {
      this.toggleStyleVariable()
    }
  }, 100)
}
